import styled, { css } from 'styled-components';

export const StyledLink = styled.a<{ $styled?: boolean }>`
  ${({ theme, $styled }) =>
    $styled &&
    css`
      color: ${theme.colors.primary.default};
      font-weight: 550;

      &:hover {
        text-decoration: underline;
      }
    `}
`;
